<template>
    <div class="flex items-center" :class="{ 'ds-exchange-user': exchange }">
        <Avatar :first-name="firstName" :last-name="lastName" :url="avatar" :class="exchange ? 'ds-assignee-avatar' : 'ml-2 mr-2'" />
        <div class="min-w-0">
            <div :class="exchange ? 'ds-assignee-name truncate' : 'text-sm text-gray'">{{ lastName }} {{ firstName }}</div>
            <div v-if="exchange && subtitle" class="ds-assignee-subtitle truncate">{{ subtitle }}</div>
        </div>
    </div>
</template>

<script setup lang="ts">
import Avatar from './Avatar.vue'
withDefaults(defineProps<{
    firstName?: string
    lastName?: string
    avatar?: string
    subtitle?: string
    exchange?: boolean
}>(), {
    firstName: '',
    lastName: '',
    avatar: '',
    subtitle: '',
    exchange: false
})
</script>
